import { render } from "./ApiDocIndex.vue?vue&type=template&id=8d43ed86"
import script from "./ApiDocIndex.vue?vue&type=script&lang=js"
export * from "./ApiDocIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__